var _rect, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultApp = function SvgDefaultApp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default_app_svg__a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#default_app_svg__b)",
    rx: 4
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M2.496 0v20M20 2.5H0M20 10H0M20 17.5H0M10 0v20M17.496 0v20",
    style: {
      mixBlendMode: "lighten"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.5,
    stroke: "#fff",
    opacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "default_app_svg__b",
    x1: 10,
    x2: 10,
    y1: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "default_app_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 4
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultApp);
export { ForwardRef as Icon };
export default "img/element-icons/room/default_app.79b63ba.svg";